define('GameDayCore/GDModel/ValueObjects/Game/GameFileTeam',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(GameFileTeam);

	function GameFileTeam($data) {
		var vo = VO.ensureVO(this, GameFileTeam),
			data = $data;

		vo.type = data.type || "";
		vo.code = data.code || "";
		vo.file_code = data.file_code || "";
		vo.abbrev = data.abbrev || "";
		vo.id = data.id || "";
		vo.name = data.name || "";
		vo.name_full = data.name_full || "";
		vo.name_brief = data.name_brief || "";
		vo.w = data.w || "";
		vo.l = data.l || "";
		vo.divisionID = data.division_id || "";
		vo.leagueID = data.league_id || "";
		vo.league = data.league || "";
	}

	return GameFileTeam;
});
